import React from 'react';
import PropTypes from 'prop-types';
import PatientBadge from 'components/Patient/PatientBadge';
import SelectableListItem from 'components/Utils/SelectableListItem';
import { DefaultList as List } from 'services/UIUtils';
import UnreadBadge from 'components/Common/UnreadBadge';
import './style.scss';
import { IconButton } from '@material-ui/core';
import Icon from 'components/Utils/NewIcon';
import DefaultConfirmationModal from 'components/Utils/DefaultConfirmationScreen';
import { TotalUnreadCount } from 'careand-redux/selectors';
import { useAppSelector } from 'careand-redux/store';
import ConfirmationDialog from 'components/Utils/ConfirmationDialog';

const AccountsListView = (props) =>
  props.activePatient &&
  props.patient && (
    <>
      <div className={'accounts-list' + (props.className ? ' ' + props.className : '')}>
        {!props.sameList && (
          <>
            {props.activePatient.id !== props.patient.id && (
              <AccountList
                {...props}
                title="Active Profile"
                patients={[props.activePatient]}
                primary={props.patient.id}
              />
            )}
            <AccountList
              {...props}
              title={
                props.activePatient.id === props.patient.id && !!props.activeId
                  ? 'Active Profile'
                  : 'Primary Profile'
              }
              patients={[props.patient]}
              primary={props.patient.id}
            />
            {props.linkedAccounts.length > 0 && (
              <AccountList
                {...props}
                title="Linked Profiles"
                patients={props.linkedAccounts}
                isParent={false}
              />
            )}
            {props.showParentAccounts && props.linkedToAccounts.length > 0 && (
              <AccountList
                {...props}
                title="Parent Profiles"
                patients={props.linkedToAccounts}
                isParent={true}
                onClick={props.isPatient ? undefined : props.onClick}
                count={props.linkedToAccounts.length}
              />
            )}
          </>
        )}
        {props.sameList && (
          <AccountList
            {...props}
            patients={[props.patient, ...props.linkedAccounts]}
            primary={props.patient.id}
          />
        )}
      </div>
      {!!props.unlinkConfirmation &&
        (props.isPatient ? (
          <DefaultConfirmationModal
            open={!!props.unlinkConfirmation}
            title="Remove Linked Account"
            icon="link-simple-slash"
            fullHeight={true}
            text={props.confirmationMessage}
            onConfirm={() => props.unlink(props.unlinkConfirmation)}
            onCancel={() => props.showConfirmation()}
          />
        ) : (
          <ConfirmationDialog
            title="Remove Linked Account"
            open={!!props.unlinkConfirmation}
            message={props.confirmationMessage}
            onConfirm={() => props.unlink(props.unlinkConfirmation)}
            onCancel={() => props.showConfirmation()}
          />
        ))}
    </>
  );

AccountsListView.propTypes = {
  patient: PropTypes.object.isRequired,
  activePatient: PropTypes.object.isRequired,
  healthRecords: PropTypes.object,
  activeId: PropTypes.string,
  sendMessage: PropTypes.func,
  linkedAccounts: PropTypes.array,
  linkedToAccounts: PropTypes.array,
  unlinkConfirmation: PropTypes.string,
  onClick: PropTypes.func,
  confirmationMessage: PropTypes.string,
  sameList: PropTypes.bool,
  highlightSelected: PropTypes.bool,
  title: PropTypes.string,
};

export const AccountList = (props) => (
  <div className="account-list">
    {props.title && <span className="small-title">{props.title}</span>}
    <AccountItems {...props} />
  </div>
);

const AccountItems = (props) => {
  const { patients = [], onClick, activeId, highlightSelected } = props;
  return (
    <List id="profile-list">
      {patients.map((patient) => (
        <SelectableListItem
          key={patient.id}
          id={'linked-account-' + patient.id}
          className={onClick && patient.id ? 'clickable linked-account' : 'linked-account'}
          padded={false}
          selected={highlightSelected && isActive(activeId, patient)}
          divider={!highlightSelected || !isActive(activeId, patient)}
          item={<PatientAccountCard {...props} patient={patient} />}
        />
      ))}
    </List>
  );
};

function PatientAccountCard({
  onClick,
  activeId,
  showConfirmation,
  primary,
  isParent,
  allowUnlink,
  patient,
}) {
  const unreadCount = useAppSelector(TotalUnreadCount(patient.id));

  const showUnlinkButton =
    allowUnlink === true && !isActive(activeId, patient) && primary !== patient.id;

  return (
    <div className="patient-account-card" onClick={() => (onClick ? onClick(patient.id) : null)}>
      <PatientBadge patient={patient} />
      <UnreadBadge unreadCount={unreadCount} />
      {showUnlinkButton && (
        <IconButton
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            showConfirmation(patient.id, isParent);
          }}
          className="unlink-button"
        >
          <Icon className="unlink" src="link-simple-slash" fontAwesomeStyle="fas" width="25px" />
        </IconButton>
      )}
    </div>
  );
}

function isActive(activeId, patient) {
  return activeId === patient.id;
}

export default AccountsListView;
